import { Card, CardContent, Typography, Box } from "@mui/material";
import { DateTimeToBr } from "../hooks/Utils";

export default function TransactionDetails({ transaction }) {
  if (!transaction) return null;

  const strPagamento = transaction.Pagamento
    ? JSON.stringify(transaction.Pagamento, null, 2)
        .replace(/"/g, "")
        .replace("{", "")
        .replace("}", "")
    : null;

  return (
    <Card sx={{ m: 2 }}>
      <CardContent sx={{ p: 0 }}>
        <Box
          sx={{
            backgroundColor: "primary.main",
            color: "primary.contrastText",
            px: 2,
            py: 1,
            borderTopLeftRadius: 4,
            borderTopRightRadius: 4,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            Detalhes da Transação
          </Typography>
        </Box>
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">
            <strong>Data:</strong> {DateTimeToBr(transaction.Data)}
          </Typography>
          <Typography variant="body2">
            <strong>ID Cobrança:</strong> {transaction.IDCobranca}
          </Typography>
          <Typography variant="body2">
            <strong>CPF:</strong> {transaction.CPF}
          </Typography>
          <Typography variant="body2">
            <strong>Nome:</strong> {transaction.Nome}
          </Typography>
          <Typography variant="body2">
            <strong>Forma:</strong> {transaction.Forma}
          </Typography>
          <Typography variant="body2">
            <strong>Status:</strong> {transaction.Status}
          </Typography>
          <Typography variant="body2">
            <strong>Valor:</strong>{" "}
            {transaction.Valor?.toLocaleString("pt-BR", {
              style: "currency",
              currency: "BRL",
            })}
          </Typography>
          {transaction.Confirmacao && (
            <Typography variant="body2">
              <strong>Confirmação:</strong> {transaction.Confirmacao}
            </Typography>
          )}
          {strPagamento && (
            <>
              <Typography variant="body2" sx={{ mt: 2 }}>
                <strong>Pagamento:</strong>
              </Typography>
              <pre
                style={{
                  fontSize: 12,
                  background: "#f5f5f5",
                  padding: 8,
                  borderRadius: 4,
                }}
              >
                {strPagamento}
              </pre>
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );
}
